import { render } from "./TransferRemovalConfirmationDialog.vue?vue&type=template&id=1d7c11eb"
import script from "./TransferRemovalConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./TransferRemovalConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__